import Axios from "axios";

export const validateOtp = async (otp) => Axios.get(`/user/reset/${otp}`).then(res => res.data);

export const resetPassword = (otp, data) => Axios.patch(`/user/reset/${otp}`, data).then(res => res.data);